// extracted by mini-css-extract-plugin
export var activeFilterButton = "_sq-c";
export var backButton = "_sq-4";
export var backIcon = "_sq-5";
export var chevronShortcut = "_sq-6";
export var container = "_sq-1";
export var editor = "_sq-8";
export var editorWrapper = "_sq-7";
export var prefix = "_sq-2";
export var searchIcon = "_sq-3";
export var suffix = "_sq-9";
export var suffixContent = "_sq-a";
export var suffixText = "_sq-b";
export var wrapper = "_sq-0";